/**
 * LuxeLight hotfix (17 Oct 2026): make bundle-builder add-to-cart resilient.
 * - Looks up the cart drawer at tap time, not once at page load, so a late or
 *   replaced drawer element is still found.
 * - If the drawer can't render, send the shopper to /cart (item is already
 *   added) instead of failing silently.
 * Safe to remove once the root cause is confirmed fixed.
 */
(function () {
  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function safeCart(el) {
    if (!el || typeof el.renderContents !== 'function') return null;
    return {
      classList: el.classList,
      getSectionsToRender: function () {
        return el.getSectionsToRender();
      },
      setActiveElement: function (target) {
        if (typeof el.setActiveElement === 'function') el.setActiveElement(target);
      },
      renderContents: function (parsed) {
        try {
          el.renderContents(parsed);
        } catch (e) {
          console.error('[luxelight-fix] cart drawer render failed', e);
          window.location = cartUrl();
        }
      },
    };
  }

  function patch() {
    var C = customElements.get('bundle-builder');
    if (!C) return false;
    if (C.prototype.__luxeFix) return true;
    var original = C.prototype.addToCart;
    C.prototype.addToCart = function () {
      var el = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cart = safeCart(el);
      return original.apply(this, arguments);
    };
    C.prototype.__luxeFix = true;
    return true;
  }

  if (!patch() && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('bundle-builder').then(patch);
  }
})();
